import React from 'react';
import IdNameEntity from './IdNameEntity';

export default class IdNameActiveEntity extends IdNameEntity {

  static shape = {
    id: React.PropTypes.string.isRequired,
    name: React.PropTypes.string.isRequired,
    active: React.PropTypes.bool.isRequired,
  };

  get text() {
    if (this.active === false) {
      return `(${this.name})`;
    }
    return this.name;
  }

}



// WEBPACK FOOTER //
// ./shared/src/entity/IdNameActiveEntity.js